export const LOGOUT_REDIRECT: string = '/login';
export const LOGIN_REDIRECT: string = '/main-dashboard';
